import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import initApp from 'utils/functions/init';
import { Contexts } from 'constants/context';
// eslint-disable-next-line max-len
import SurgicalProvidersAndServicesContainerSelector from 'modules/categories/surgical/container/SurgicalProvidersAndServicesContainer/SurgicalProvidersAndServicesContainerSelector';
import { fetchDropdowns } from 'modules/categories/categoriesSlice';
import { useParams } from 'react-router-dom';
import { fetchSelectedealthPlan } from 'modules/healthPlans/healthPlansSlice';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const SurgicalProvidersPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { healthPlanId } = useParams();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    initApp(Contexts.Surgical);
    dispatch(fetchDropdowns());
    dispatch(fetchSelectedealthPlan(healthPlanId));
  }, [dispatch]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <SurgicalProvidersAndServicesContainerSelector />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

SurgicalProvidersPage.propTypes = {};

SurgicalProvidersPage.defaultProps = {};

export default SurgicalProvidersPage;
